/** The signed-in site owner (or any other Firebase account, which can't edit). */
export class JCalAuth {
    constructor(
        readonly uid: string,
        readonly email: string | null,
        /** The `admin` custom claim; the only role that can edit projects. */
        readonly isAdmin: boolean,
    ) { }
}
